<template>
    <el-scrollbar>
        <div class="learning_analysis_center">
            <div class="learning_main">
                <div style="width: 100%;" class="header">
                    <span class="class_label">班级:</span>
                    <el-select style="z-index:999" ref="classNameRef" v-model="selectClassGradId" clearable
                        placeholder="请选择" @change="changeSelectClassGrad">
                        <el-option v-for="item in classGradData" :key="item.c_id" :label="item.c_name" :value="item.c_id">
                        </el-option>
                    </el-select>
                </div>
                <div class="information_main">
                    <p class="label_title">课程统计分析</p>
                    <div class="class_echarts" ref="classEcharts">

                    </div>
                    <p class="label_title">学生成绩</p>
                    <div class="student_box">
                        <div class="student_header">
                            <span class="class_label">课程:</span>
                            <el-select style="z-index:999" ref="classNameRef" v-model="selectCourseId" clearable
                                placeholder="请选择" @change="clickClassName">
                                <el-option v-for="item in curriculumGuidanceData" :key="item.course_id"
                                    :label="item.course_name" :value="item.course_id">
                                </el-option>
                            </el-select>
                            <span class="class_label stu_class_label">学生:</span>
                            <el-select v-model="selectStudentId" placeholder="请选择" @change="changeSelectStudent">
                                <el-option v-for="item in studentList" :key="item.s_id" :label="item.s_name"
                                    :value="item.s_id">
                                </el-option>
                            </el-select>


                        </div>
                        <p class="name">作业成绩</p>
                        <el-table :data="jobScoreData" stripe
                            style="width: 100%; height: 348px; flex: 1; border: 1px solid #EBEEF5;  border-radius: 4px;"
                            :header-cell-style="headStyle" :cell-style="cellStyle">
                            <el-table-column prop="name" label="作业名称" width="520">
                            </el-table-column>
                            <el-table-column prop="status" label="学生作业完成情况" >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.status==0" style="color: #FF3E3E;">未完成</span>
                                    <span v-else>已完成</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="score" label="学生随堂检测成绩">
                            </el-table-column>
                            <el-table-column label="操作" width="120">
                                <template slot-scope="scope">
                                    <el-link  style="color:#006EFF;" :underline="false"
                                    @click="getJobDetail(scope.row)">查看详情</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination background @current-change="handleCurrentChangeJob"
                                :current-page.sync="jobScore.page" :page-size="jobScore.limit"
                                layout="prev, pager, next, jumper" :total="jobScore.total">
                            </el-pagination>
                        </div>

                        <p>考试成绩</p>
                        <el-table :data="examScoreData" stripe
                            style="width: 100%; height: 348px; flex: 1; border: 1px solid #EBEEF5; border-bottom: none; border-radius: 4px;"
                            :header-cell-style="headStyle" :cell-style="cellStyle">
                            <el-table-column prop="name" label="考试名称" width="520">
                            </el-table-column>
                            <el-table-column prop="status" label="实训任务学习情况" >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.status==0" style="color: #FF3E3E;">未完成</span>
                                    <span v-else>已完成</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="score" label="学生考试成绩" >
                            </el-table-column>
                            <el-table-column label="操作" width="120">
                                <template slot-scope="scope">
                                    <el-link  style="color:#006EFF; cursor: pointer;" :underline="false"
                                    @click="getTrainingDetail(scope.row)">查看详情</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination background @current-change="handleCurrentChangeScore"
                                :current-page.sync="examScore.page" :page-size="examScore.limit"
                                layout="prev, pager, next, jumper" :total="examScore.total">
                            </el-pagination>
                        </div>
                    </div>
                    <p class="label_title">课程对比分析</p>
                    <div class="traing_echarts">
                        <div class="echarts_box">
                            <div class="echarts_title">课程训练次数对比</div>
                            <div class="echarts" ref="trainEcharts">
                            </div>
                        </div>
                        <div class="echarts_box echarts1">
                            <div class="echarts_header">
                                <span>学生活跃对比</span>
                                <el-select style="z-index:999" ref="classNameRef" v-model="course_id" clearable
                                    placeholder="请选择" @change="clickClassNameStudent">
                                    <el-option v-for="item in curriculumGuidanceData" :key="item.course_id"
                                        :label="item.course_name" :value="item.course_id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="echarts" ref="studentEcharts">

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </el-scrollbar>
</template>
<script>

export default {
    data() {
        return {
            classGradData: [],//班级列表
            selectClassGradId: "",
            curriculumGuidanceData: [],//课程列表
            selectCourseId: "",
            studentList: [],
            selectStudentId: "",
            selectComparisonCourseId: '',
            jobScore: {
                page: 1,
                limit: 5,
                total: 0
            },
            examScore: {
                page: 1,
                limit: 5,
                total: 0
            },
            practicalTrainingData: [],//考试数据  实训
            jobScoreData: [],
            examScoreData: [],
            course_id:""


        }
    },
    methods: {
        headStyle() {
            return 'background: #FAFAFA; fontWeight: 500; font-family: PingFang SC, PingFang SC; padding-left: 24px; color:#3E3E3E; height: 42px;'
        },
        cellStyle() {
            return 'padding-left: 24px; height: 60px; color: #333;'
        },
        getClassList() {
            // 获取班级列表   --> 获取课程列表-->获取学生列表
            let params = {
                no_paging: 1,
            }
            this.$shttp.axiosGetBy(this.$api.statistics, params, (res) => {
                if (res.code === 200) {
                    this.classGradData = res.data.data
                    // console.log(res.data.data, "res.data.data");
                    this.selectClassGradId = this.classGradData.length > 0 ? this.classGradData[0].c_id : ""
                    this.getCourseOverviewData()
                    this.getCurriculumAnalysisEcharts()
                    this.getClassTaingEchartsData()
                }
            })
        },
        getCourseOverviewData() {
            let params = {
                class_id: this.selectClassGradId
            }
            this.$shttp.axiosGetBy(this.$api.adminGetCourseList, params, (res) => {
                // console.log(res, "课程选择模块");
                if (res.code == 200) {
                    // this.courseOverviewData = res.data.overview
                    this.curriculumGuidanceData = res.data.guide
                    this.selectCourseId = this.curriculumGuidanceData.length > 0 ? this.curriculumGuidanceData[0].course_id : ""
                    this.course_id=this.curriculumGuidanceData.length > 0 ? this.curriculumGuidanceData[0].course_id : ""
                    this.getStudentList()
                    this.getClassTaingEchartsData()
                    this.getgetStudentEchartsData()
                }

            })
        },
        getStudentList() {
            let params = {
                type: 'all',
                c_id: this.selectClassGradId
            }
            this.$shttp.axiosGetBy(this.$api.showStudent, params, (res) => {
                if (res.code === 200) {
                    if (res.data.length) {
                        this.studentList = res.data;
                        // console.log(this.studentList, "学生列表");
                        this.selectStudentId = res.data[0].s_id
                        this.selectStudentName = res.data[0].s_name;
                        this.selectClassName = res.data[0].c_name
                        // this.getJobData()
                        // this.getPracticalTrainingData()
                        this.getJobScoreData()
                        this.getExamScoreData()
                    }
                }
            }, (err) => {
                console.log(err)
            })
        },
        changeSelectClassGrad() {
            this.getCourseOverviewData()
            this.getCurriculumAnalysisEcharts()
        },
        clickClassName() {
            this.getJobScoreData()
            this.getExamScoreData()
        },
        changeSelectStudent() {
            this.getJobScoreData()
            this.getExamScoreData()
        },
        getCurriculumAnalysisEcharts() {
            let analysisData = []
            let xAxisData = []
            let params = {
                class_id: this.selectClassGradId
            }
            this.$shttp.axiosGetBy(this.$api.adminAnalysisData, params, (res) => {
                // console.log(res.data, "课程选择模块");
                if (res.code == 200) {
                    // this.courseOverviewData = res.data.overview
                    analysisData = res.data.chart_data
                    // console.log(analysisData,"课程数据");
                    if (res.data.course.length > 0) {
                        res.data.course.forEach(item => {
                            xAxisData.push(item.course_name)
                        })
                        this.getEcharts(xAxisData, analysisData)
                    }

                }

            })
        },

        getEcharts(xAxisData, analysisData) {
            // console.log(analysisData,"数据");
            var chart = this.$echarts.init(this.$refs.classEcharts)
            let option = {
                tooltip: {
                    trigger: 'axis',
                    className: 'echarts-tooltip',
                    backgroundColor:"rgba(0,0,0,.8)",
                    formatter: function(params) {
                        // console.log(params,"params");
                        var result = "<div style='padding:5px 10px;'>"+params[0].name+'<br>'+"</div>";
                        params.forEach(function(item,index) {
                        if(item.seriesName=='课程训练次数'){
                            result +="<div style='padding:5px 10px'>"+item.seriesName+" : "+'<span style="color:#5C9DFF">'+ item.value+"次</span><br>"+'</div>'
                        }else{
                            result +="<div style='padding:5px 10px'>"+item.seriesName+" : "+'<span style="color:#14C9C9">'+ item.value+"%</span><br>"+'</div>'
                        }
                        });
                        return result;
                    }
                },
                grid: {
                    left: "4%",
                    right: "5%"

                },
                legend: {
                    data: [
                        {
                            name: "课程训练次数",
                            icon: "circle",
                            color: "#165DFF",
                        },
                        {
                            name: "课程进度",
                            icon: "circle",
                            color: "#14C9C9 ",
                        },
                    ],
                },

                xAxis: {
                    type: 'category',
                    axisLabel: {
                        show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
                        textStyle: {
                            //textStyle里面写y轴下的字体的样式
                            color: '#0072DB',
                            fontSize: 12,
                        },
                        formatter: '{value}',
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#0072DB', // 设定 y 轴线的颜色
                            width: 1,         // 设定 y 轴线的宽度
                            type: 'solid'    // 设定 y 轴线的类型，可选：'solid', 'dashed', 'dotted'
                        }
                    },
                    boundaryGap: false,
                    data: xAxisData
                },
                yAxis: [
                    {
                    type: 'value',
                    name: "课程训练次数",
                    nameTextStyle: {
                        color: "#666666",
                        fontSize: 12,
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            //textStyle里面写y轴下的字体的样式
                            color: '#0072DB',
                            fontSize: 12,
                        },
                        formatter: '{value}'
                    },
                    axisTick: {       // 坐标轴刻度
                        show: false   // 不显示刻度
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#0072DB', // 设定 y 轴线的颜色
                            width: 1,         // 设定 y 轴线的宽度
                            type: 'solid'    // 设定 y 轴线的类型，可选：'solid', 'dashed', 'dotted'
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#0072DB',
                            type: 'dotted',
                          
                        }
                    }
                }, {
                    type: 'value',
                    name: "课程进度",
                    nameTextStyle: {
                        color: "#666666",
                        fontSize: 12,
                    },
                    min: 0,
                    max: 100,
                    interval: 20,
                    axisLabel: {
                        show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
                        textStyle: {
                            //textStyle里面写y轴下的字体的样式
                            color: '#0072DB',
                            fontSize: 12,
                        },
                        formatter: '{value}%',
                    },
                    axisLine: {       // 坐标轴线
                        show: false,   // 默认显示，设为false则代表不显示
                    },
                    axisTick: {       // 坐标轴刻度
                        show: false   // 不显示刻度
                    },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: '#0072DB',
                            type: 'dotted',
                            
                        }
                    }
                }],
                series: [
                    {
                        name: '课程训练次数',
                        type: 'line',
                        data: analysisData[0].data,
                        color: "#165DFF",
                        yAxisIndex: 0

                    },
                    {
                        name: '课程进度',
                        type: 'line',
                        data: analysisData[1].data,
                        color: "#14C9C9 ",
                        yAxisIndex: 1
                    }

                ]
            };
            chart.setOption(option);

        },
        // 获取作业成绩和考试成绩
        getJobScoreData() {
            let params = {
                class_id: this.selectClassGradId,
                s_id: this.selectStudentId,
                course_id: this.selectCourseId,
                page: this.jobScore.page,
                limit: this.jobScore.limit,
                name: '',
                item_state: ''
            }
            this.$shttp.axiosGetBy(this.$api.adminGetExamList, params, (res) => {
                // console.log(res.data, "课1");
                if (res.code == 200) {
                    this.jobScoreData = res.data.list
                    this.jobScore.total = res.data.total
                }

            })


        },
        getExamScoreData() {
            let params = {
                class_id: this.selectClassGradId,
                s_id: this.selectStudentId,
                course_id: this.selectCourseId,
                page: this.examScore.page,
                limit: this.examScore.limit,
                name: '',
                item_state: ''
            }
            this.$shttp.axiosGetBy(this.$api.adminGetShixunList, params, (res) => {
                if (res.code == 200) {
                    this.examScoreData = res.data.list
                    this.examScore.total = res.data.total
                }

            })
        },
        getClassTaingEchartsData() {
            let xAxisData=[]
            let yAxisData=[]
            let params = {
                class_id:this.selectClassGradId
            }
            this.$shttp.axiosGetBy(this.$api.adminTrainChartData, params, (res) => {
                if (res.code == 200) {
                   xAxisData=res.data.course
                   yAxisData=res.data.chart_data
                //    console.log(xAxisData,"ppppp");
                    this.getClassTaingEcharts(xAxisData,yAxisData)
                }

            })
         

        },
        getgetStudentEchartsData(){
            let xAxisData=[]
            let yAxisData=[]
            let params = {
                class_id:this.selectClassGradId,
                course_id:this.course_id
            }
            this.$shttp.axiosGetBy(this.$api.adminSignChartData, params, (res) => {
                if (res.code == 200) {
                    xAxisData=res.data.student
                    // yAxisData=res.data.chart_data
                    // console.log(yAxisData,"活跃");
                    res.data.chart_data.forEach(item=>{
                        let number = parseFloat(item.replace('%', ''));
                        yAxisData.push(number)
                    })
                    // console.log("xAxisData",xAxisData);
                    this.getStudentEcharts(xAxisData,yAxisData)
                }

            })
            // let xAxisData=["李明1","李明2","李明3","李明4","李明5","李明6","李明7","李明8","李明9","李明10","李明11","李明12","李明13","李明14","李明15","李明16","李明17","李明18","李明19","李明20","李明21","李明22","李明23","李明24","李明25",]
            // let yAxisData=[11,21,31,41,51,61,71,81,91,20,11,21,31,41,51,61,71,81,91,30,11,21,31,41,51]
            // this.getStudentEcharts(xAxisData,yAxisData)
        },
        // 分页
        handleCurrentChangeJob(val) {
            this.jobScore.page = val
            this.getJobScoreData()
        },
        handleCurrentChangeScore(val) {
            this.examScore.page = val
            this.getExamScoreData()
        },
        getClassTaingEcharts(xAxisData,yAxisData) {
            let max=Math.max(...yAxisData);
            max=max>10?max:10
            var chart = this.$echarts.init(this.$refs.trainEcharts)
            var option = {
                tooltip: {
                    trigger: 'axis',
                    className: 'echarts-tooltip1',
                    backgroundColor:"rgba(0,0,0,.8)",
                    formatter: function(params) {
                        var result = "<div style='padding:5px 10px;'>"+'课程训练次数'+'<br>'+"</div>";
                        params.forEach(function(item) {
                     
                        result +="<div style='padding:5px 10px'>"+item.name+" : "+'<span style="color:#165DFF">'+ item.value+"次</span><br>"+'</div>'
                        
                        });
                        return result;
                    }
                },
                xAxis: {
                    type: 'category',
                    axisTick: {       // 坐标轴刻度
                        show: false   // 不显示刻度
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#C9CDD4', // 设定 y 轴线的颜色
                            width: 1,         // 设定 y 轴线的宽度
                            type: 'solid'    // 设定 y 轴线的类型，可选：'solid', 'dashed', 'dotted'
                        }
                    },
                    data:xAxisData
                },

                yAxis: {
                    type: 'value',
                    name: "课程训练次数",
                    nameTextStyle: {
                        color: "#C9CDD4",
                        fontSize: 12,
                    },
                    min: 0,
                    max: max,
                    interval: 2,
                    axisLabel: {
                        show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
                        textStyle: {
                            //textStyle里面写y轴下的字体的样式
                            color: '#C9CDD4',
                            fontSize: 12,
                        },
                        formatter: '{value}',
                    },
                    axisLine: {       // 坐标轴线
                        show: false,   // 默认显示，设为false则代表不显示
                    },
                    axisTick: {       // 坐标轴刻度
                        show: false   // 不显示刻度
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#C9CDD4',
                            type: 'dotted',
                            width: 0.8
                        }
                    }
                },
                series: [
                    {
                        data:yAxisData,
                        type: 'bar',
                        color: "#165DFF",
                        barWidth:30,
                    }
                ]
            };
            chart.setOption(option);


        },
        getStudentEcharts(xAxisData,yAxisData) {
            // studentEcharts
            var chart = this.$echarts.init(this.$refs.studentEcharts)
            var option = {
                tooltip: {
                    trigger: 'axis',
                    className: 'echarts-tooltip1',
                    backgroundColor:"rgba(0,0,0,.8)",
                    formatter: function(params) {
                        var result = "<div style='padding:5px 10px;'>"+'签到率'+'<br>'+"</div>";
                        params.forEach(function(item) {
                     
                        result +="<div style='padding:5px 10px'>"+item.name+" : "+'<span style="color:#165DFF">'+ item.value+"%</span><br>"+'</div>'
                        
                        });
                        return result;
                    }
                },
                xAxis: {
                    type: 'category',
                    axisTick: {       // 坐标轴刻度
                        show: false   // 不显示刻度
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#C9CDD4 ', // 设定 y 轴线的颜色
                            width: 1,         // 设定 y 轴线的宽度
                            type: 'solid'    // 设定 y 轴线的类型，可选：'solid', 'dashed', 'dotted'
                        }
                    },
                    boundaryGap: false,
                    data:xAxisData
                },
                yAxis: {
                    type: 'value',
                    name: "签到率",
                    nameTextStyle: {
                        color: "#C9CDD4",
                        fontSize: 12,
                    },
                    max:100,
                    min:0,


                    axisLabel: {
                        show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
                        textStyle: {
                            //textStyle里面写y轴下的字体的样式
                            color: '#C9CDD4',
                            fontSize: 12,
                        },
                        formatter: '{value}%',
                    },
                    axisLine: {       // 坐标轴线
                        show: false,   // 默认显示，设为false则代表不显示
                    },
                    axisTick: {       // 坐标轴刻度
                        show: false   // 不显示刻度
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#C9CDD4',
                            type: 'dotted',
                          
                        }
                    }
                },
                series: [
                    {
                        data: yAxisData,
                        type: 'line',
                        areaStyle: {
                            opacity: 0.4,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: "rgba(22,93,255,0.2)" },
                                { offset: 1, color: "rgba(22,93,255,0)" },])
                        },
                        color:"rgba(22,93,255,0.2)"
                    },

                ]
            };
            chart.setOption(option);

        },
        clickClassNameStudent(){
            this.getgetStudentEchartsData()
        },
        getJobDetail(item){
            if(item.status!=2){
                this.$message.warning("该学生未完成实训任务")
                return false
            }
            this.$router.push({
                path: '/analysis/allApprovedDetail',
                query: {
                    quizId: item.id,
                    studentId: this.selectStudentId,
                    classId: this.selectClassGradId,
                    className: this.selectClassName,
                    paperName: item.name,
                    studentName: this.selectStudentName,
                }
            })
        },
        getTrainingDetail(item){
            if(item.status!=2){
                this.$message.warning("该学生未完成实训任务")
                return false
            }
           this.$router.push({
                path: '/analysis/practicalDetail',
                query: {
                    p_id: item.project_id,
                    sx_id: item.id,
                    className: this.selectClassName
                }
            })
            
        }



    },
    mounted() {
        this.getClassList()
        this.getCurriculumAnalysisEcharts()
        
    }
}


</script>
<style lang="scss" scoped>
.learning_analysis_center {
    width: 100%;
    background-color: #F4F5F9;
    height: 100%;
    display: flex;
    justify-content: center;


    .learning_main {
        width: 80%;
        padding-bottom: 30px;
        box-sizing: border-box;
        margin-top: 20px;

        background-color: #ffffff;

        .header {
            width: 100%;
            height: 68px;
            display: flex;
            align-items: center;

            box-sizing: border-box;
            border-bottom: 1px solid #EAEDF4;

            .class_label {
                padding: 0 22px;
            }
        }
    }

    .information_main {
        width: 100%;
        padding: 22px;
        box-sizing: border-box;

        .label_title {
            position: relative;
            margin: 20px 0;
            padding-left: 20px;
            height: 20px;


            /* 为了给竖条留出空间 */
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 4px;
                /* 竖条的宽度 */
                height: 100%;
                /* 竖条的高度，与内容区域高度一致 */
                background-color: #409EFF;
                /* 竖条的颜色 */
            }

        }

        .class_echarts {
            width: 100%;
            // background-color: rgb(227, 221, 222);
            height: 315px;
        }

        .student_box {
            .student_header {
                .class_label {
                    padding-right: 22px;
                }

                .stu_class_label {
                    padding-left: 40px;
                }

            }

            .name {
                margin-top: 30px;

            }

            .pagination {
                width: 100%;
                display: flex;
                justify-content: center;
                margin: 20px 0;

            }

        }

        .traing_echarts {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .echarts_box {
                flex: 1;
                width: 0;
                height: 390px;
                border-radius: 12px 12px 12px 12px;
                border: 1px solid #E7E7E7;

                .echarts {
                    width: 100%;
                    height: 330px;
                }

                .echarts_title {
                    width: 100%;
                    height: 60px;
                    padding: 0 20px;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;

                }

                .echarts_header {
                    width: 100%;
                    height: 60px;
                    padding: 0 20px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    box-sizing: border-box;
                }
            }

            .echarts1 {
                margin-left: 20px;
            }
        }

    }


}

::v-deep .el-input__inner {
    width: 300px;
    height: 36px;
}

.el-pagination {
    ::v-deep .el-input__inner {
        width: 50px !important;
        height: 28px;
    }
}
::v-deep .el-tooltip__popper{
  
      background-color: #004bc2 !important;

      font-size: 17px;

  }
</style>